import React, { useState, memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Icon } from '@alycecom/ui';

import { getStatuses } from '../../modules/RecipientModule/store/statuses/statuses.selectors';
import { IAlyceCustomTheme } from '../../styles/alyceTheme';

const useStyles = makeStyles<IAlyceCustomTheme>(({ palette, spacing, breakpoints }) => ({
  title: {
    marginRight: spacing(1),
  },
  icon: {
    color: palette.text.primary,
    marginRight: spacing(1),
  },
  closeIcon: {
    color: palette.text.primary,
    position: 'absolute',
    top: 10,
    right: 20,
    [breakpoints.down('sm')]: {
      top: 0,
      right: 10,
    },
  },
}));

export interface IReadOnlyModeProps {
  isCampaignPreview?: boolean;
  campaignName?: string;
}

const ReadOnlyMode = ({ isCampaignPreview = false, campaignName }: IReadOnlyModeProps): JSX.Element => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(true);

  const statuses = useSelector(getStatuses);

  const isPreviewModeMessageVisible = (statuses.draft || statuses.preview || isCampaignPreview) && isVisible;
  const previewTitle = isCampaignPreview ? `${campaignName} preview.` : 'You are in gift preview mode.';

  const handleClosePreviewTip = useCallback(() => setIsVisible(false), []);

  return isPreviewModeMessageVisible ? (
    <Box
      position="fixed"
      width={1}
      height={['auto', 40]}
      top={0}
      px={1}
      bgcolor="secondary.main"
      zIndex={1500}
      textAlign="center"
      display="flex"
      flexDirection={['column', 'row']}
      justifyContent="center"
      alignItems="center"
    >
      <Icon icon="eye" className={classes.icon} />
      <Typography className={classNames('Body-Regular-Center-Static-Bold', classes.title)}>{previewTitle}</Typography>
      <Typography className="Body-Regular-Center-Static">
        Any actions you take here will not affect the gift.
      </Typography>
      <Icon icon="times" className={classes.closeIcon} onClick={handleClosePreviewTip} />
    </Box>
  ) : (
    <></>
  );
};

export default memo<IReadOnlyModeProps>(ReadOnlyMode);
